import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promoteB';

export const originSolarPartnerPlusDefaultFuelKeyDetails = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable',
    modalContent: PlanKeyDetailsModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable rates',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue: '12 months' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 month benefit period',
  },
];

export const originSolarPartnerPlusContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Solar Partner Plus']),
  content: {
    keyDetails: {
      defaultState: {
        defaultFuel: originSolarPartnerPlusDefaultFuelKeyDetails,
        electricity: originSolarPartnerPlusDefaultFuelKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        electricity: electricityKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
  },
};
